export function rangeIso(days: number): { from: string; to: string } {
  const to = new Date();
  const from = new Date(to.getTime() - days * 24 * 60 * 60 * 1000);
  return { from: from.toISOString(), to: to.toISOString() };
}

export function formatTokens(n?: number | null): string {
  if (n == null) return '—';
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return String(n);
}

/** Short session id for tables: first 8 chars + ellipsis (full id via title). */
export function formatSessionId(sessionId?: string | null): string {
  if (!sessionId) return '—';
  const compact = sessionId.replace(/-/g, '');
  if (compact.length <= 8) return sessionId;
  return `${compact.slice(0, 8)}…`;
}

export function formatPct(n?: number | null): string | null {
  if (n == null) return null;
  const sign = n > 0 ? '+' : '';
  return `${sign}${n}%`;
}

export function isCostQuery(text: string): boolean {
  const lower = text.toLowerCase();
  return (
    lower.includes('cost') ||
    lower.includes('invoice') ||
    lower.includes('charge') ||
    lower.includes('spend') ||
    lower.includes('$')
  );
}
